import * as React from "react"
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby"
 import KidsNavigation from "./Navigation/KidsNavigation"; // TODO: update to child nav
import KidsFooter from "./../components/Footer/KidsFooter" // TODO: update to child footer
import ChildAPI from '../utils/childapi'
import CookieConsent from "../utils/cookieconsent";
import Notification from './../utils/notification';
import Analytic from "../utils/analytic";



const query = graphql`
  query kidsGlobal {
    site {
      siteMetadata {
        defaultTitle: title
      }
    }
		prismicEepsCookieBanner {
			data {
				accept_label
				reject_label
				title
				image {
					localFile {
						...secondaryImage
					}
					alt
				}
				description {
					html
				}
			}
	  }
  }
`

const KidsLayout = ({ title, description, children, navigation=true }) => {

  const { site, prismicEepsCookieBanner } = useStaticQuery(query)


  return (
    <div className="global-wrapper kids">
			<ChildAPI>
				<Helmet htmlAttributes={{ lang: 'en'}}>
					<title>{title || site.siteMetadata.defaultTitle}</title>
					{ description && ( <meta property="og:description" content={description} />)}

					<meta property="og:title" content={title || site.siteMetadata.defaultTitle} />
					<meta property="og:image" content={`${process.env.GATSBY_APP_DOMAIN }/SSCardl.png`}/>
					<meta property="og:url" content={process.env.GATSBY_APP_DOMAIN}/>
					
					
					<meta name="twitter:card" content={`${process.env.GATSBY_APP_DOMAIN }/SSCards.png`}/>
					<meta property="og:site_name" content={title || site.siteMetadata.defaultTitle}/>
					<meta name="twitter:image:alt" content={title || site.siteMetadata.defaultTitle}/>
				</Helmet>
				<Analytic pageTitle={title}>
					<CookieConsent data={prismicEepsCookieBanner} >
						{ navigation ? <KidsNavigation /> : null } 
						
						<Notification>
							<main>
								{children}
							</main>
						</Notification>

						{ navigation ? <KidsFooter /> : null }
					</CookieConsent>
				</Analytic>	
			</ChildAPI>
    </div>
  )
}

export default KidsLayout
